import { useAuthContext } from "./AuthContext";

// TODO(role-gating): replace with real role check once a user-role API exists.
// For now, all authenticated users can update. When the role API ships,
// this hook should read the role from AuthContext (or a new user query) and
// return something like `role === "QCIT" || role === "SUPER_ADMIN"`.
export function useCanUpdate(): boolean {
  const { isAuthenticated } = useAuthContext();
  return isAuthenticated;
}
